import React from 'react';
const PRODUCT_IMAGE = 'https://cdn.magicpatterns.com/patterns/generated-images/3301e753-6f96-4557-b787-5c2d90e3e293.jpg';
export function Revelation() {
  return <section className="w-full border-y border-line bg-surface" data-id="element-120" data-mp="3sxyrjhxrliz4">
      <div className="mx-auto grid max-w-6xl grid-cols-1 items-center gap-12 px-5 py-20 sm:px-8 lg:grid-cols-2 lg:gap-16 lg:py-28" data-id="element-121" data-mp="1sytvkiafnyd">
        <img src={PRODUCT_IMAGE} alt="The HYROX Coach Blueprint manual shown alongside a tablet displaying a training program" className="w-full rounded-sm object-cover" data-id="element-122" data-mp="6ma1hnuxc8rc" />
        <div data-id="element-123" data-mp="fjkbl5w09ruo">
          <p className="font-sans text-xs font-semibold uppercase tracking-[0.22em] text-volt" data-id="element-124" data-mp="fjc2lp3076or">
            Introducing
          </p>
          <h2 className="mt-4 font-display text-5xl font-extrabold uppercase leading-[0.95] tracking-tightest text-white sm:text-6xl" data-id="element-125" data-mp="pj2t7fog11jk">
            The HYROX Coach Blueprint
          </h2>
          <p className="mt-6 font-display text-3xl font-bold uppercase leading-none tracking-tightest text-volt" data-id="element-126" data-mp="2raoc5zy9skse">
            Stop guessing. Start programming.
          </p>
          <div className="mt-6 space-y-5 font-sans text-lg leading-relaxed text-muted" data-id="element-127" data-mp="3hj2tkj1dse5q">
            <p data-id="element-128" data-mp="3cphyayr69ya8">
              We spent months deconstructing the physics, physiology, and
              tactics of the world’s best HYROX performances. We didn’t look for
              fitness tips. We looked for a method.
            </p>
            <p data-id="element-129" data-mp="4b9ikr9r11zh">
              The result is a comprehensive system designed specifically for
              coaches who want to dominate the market and prepare athletes for
              the podium.
            </p>
          </div>
        </div>
      </div>
    </section>;
}